<template>
  <div class="minimart-customer-dash">
    <NavBar />
    <v-main>
      <v-container class="pb-5">
        <transition name="fade" mode="out-in" appear>
          <slot />
          <router-view :key="$route.name" />
        </transition>
      </v-container>
    </v-main>
    <Footer />
    <v-snackbar
      :value="showSessionCountdown && !!expiryMessage"
      :timeout="-1"
      color="black"
    >
      <div class="text-h6">{{ expiryMessage }}</div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import NavBar from '@/components/NavBar'
import Footer from '@/components/Footer'

export default {
  name: 'CustomerDashLayout',
  components: { NavBar, Footer },
  props: {
    layout: String,
  },
  data: () => ({
    validateSessionInterval: null,
    updateExpiryMessageInterval: null,
    expiryMessage: '',
    validationPeriodInSeconds: 60,
  }),
  async created() {
    // await this.validateSession()
    if (!this.validateSessionInterval) {
      this.validateSessionInterval = setInterval(
        this.validateSession,
        this.validationPeriodInSeconds * 1000
      )
    }
    if (!this.updateExpiryMessageInterval) {
      this.updateExpiryMessageInterval = setInterval(
        this.updateExpiryMessage,
        1000
      )
    }
  },
  computed: {
    ...mapGetters('auth', [
      'getSessionExpiryInSeconds',
      'getSessionExpiryVerbal',
      'isExpired',
      'showSessionCountdown',
    ]),
  },
  methods: {
    ...mapActions('auth', ['validateSession']),
    updateExpiryMessage() {
      this.expiryMessage = `Logging out in ${this.getSessionExpiryVerbal}`
    }, // updateExpiryMessage
  },
  beforeDestroy() {
    clearInterval(this.validateSessionInterval)
    clearInterval(this.updateExpiryMessageInterval)
  },
}
</script>
